import { useContext, useEffect, useState } from 'react';

import { ViewerContext } from '@vimeo/viewer';

import { useAppendRecaptchaEnterpriseTokenScript } from './useAppendRecaptchaEnterpriseTokenScript';

export function useRecaptchaEnterpriseToken(isRecaptchaEnabledForSignup: boolean) {
  const viewer = useContext(ViewerContext);
  const [recaptchaEnterpriseToken, setRecaptchaEnterpriseToken] = useState<string | null>(null);

  if (!isRecaptchaEnabledForSignup) {
    return '';
  }

  useAppendRecaptchaEnterpriseTokenScript(viewer);

  useEffect(() => {
    const handleRecaptchaTokenLoaded = function () {
      setRecaptchaEnterpriseToken(window.recaptcha_enterprise_token);
    };
    document.addEventListener('recaptcha-token-loaded', handleRecaptchaTokenLoaded);
    return () => {
      document.removeEventListener('recaptcha-token-loaded', handleRecaptchaTokenLoaded);
    };
  }, []);

  return recaptchaEnterpriseToken;
}
